import type { FulfillmentBudgetImportReport } from "../../types";
import { formatConfirmationAmount } from "../../service/confirmationDecimalDisplay";

/** 导入结果随工作区回读，未转换项始终可供计调对照补录。 */
export function ConfirmationBudgetImportReport({ report }: { report?: FulfillmentBudgetImportReport | null }) {
  if (!report) return null;
  return <section className="confirmation-import-report" aria-label="核价导入结果">
    <strong>来源核价：V{report.version_no} · {report.version_name}</strong>
    <p>已导入 {report.imported_count} 项，金额 {formatConfirmationAmount(report.imported_amount)}。请核对实际服务、供应商及金额。</p>
    <small>导入时间：{report.imported_at.replace("T", " ").slice(0, 19)} · 核价后续修改不会自动更新确认件。</small>
    {report.issues.length ? <div className="confirmation-import-issues"><table aria-label="核价未导入明细"><thead><tr><th>核价行</th><th>类别 / 项目</th><th>核价金额</th><th>处理说明</th></tr></thead><tbody>{report.issues.map(issue => <tr key={issue.source_line_id}><td>{issue.line_no}</td><td>{issue.category} · {issue.name}</td><td>{formatConfirmationAmount(issue.amount)}</td><td>{issue.reason}</td></tr>)}</tbody></table></div> : <p>本次可转换费用已全部导入。</p>}
  </section>;
}
